import Container from '@material-ui/core/Container';
import { Formik } from 'formik';
import React from 'react';
import { useGlobal } from '@rcg/ui-react';
// eslint-disable-next-line import/no-named-as-default
import Fields from './fields';
import useStyles from './index.style';
import validationSchema from './index.validation';
import { MAX_NUMBER_OF_GUESTS } from '../../commons';

const FormFutureCruiseCredit = (reservation) => {
  const { showEmailInput } = reservation;
  const values = [...Array(parseInt(MAX_NUMBER_OF_GUESTS, 10)).keys()].reduce(
    (accumulator, currentValue) => {
      return {
        ...accumulator,
        [`cruiseCredit_${currentValue}`]: '',
      };
    },
    {},
  );

  const classes = useStyles();
  const { renderContent } = useGlobal();
  return (
    <Container maxWidth="sm" className={[classes.layout, 'FormFutureCruiseCredit'].join(' ')}>
      <Formik
        initialValues={values}
        validationSchema={validationSchema(renderContent, showEmailInput)}>
        {(props) => <Fields {...{ ...props, ...reservation }} />}
      </Formik>
    </Container>
  );
};

export default FormFutureCruiseCredit;
